import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CalendlyTopicDialogComponent } from './calendly-topic-dialog/calendly-topic-dialog.component';
import { ActivatedRoute,  } from '@angular/router';
import { CalendlyService } from './services/calendly-service';
import { TopicGroup, TopicOption, UserDetails } from './interfaces/calendely.interface';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, MatDialogModule, ],
  templateUrl: './app.component.html',
  styleUrls: [],
})
export class AppComponent implements OnInit {
  title = signal('zendesk-calendly');
  userDetails!: UserDetails;
  topicsubtopics:TopicGroup[] = [];
  dialog = inject(MatDialog);
  route = inject(ActivatedRoute);
  calendlyService = inject(CalendlyService);

   ngOnInit() {
    this.route.queryParams.subscribe(async params => {
      if (Object.keys(params).length === 0) return;
      this.userDetails = JSON.parse(atob(decodeURIComponent(params['info']))) as UserDetails; 
    
      if (!this.userDetails.brandName) {
        console.error("No brandName received!");
        return;
      }
      // Ensure config is loaded before making API calls
      await this.calendlyService.ensureConfigLoaded();
      
      this.calendlyService.getTopics(this.userDetails.brandName.toLowerCase()).subscribe((response) => {
        console.log("API Response:", response);
        if (response.brandName && (this.userDetails.brandName.toLowerCase() !== response.brandName.toLowerCase())) {
          console.error(`Brand mismatch: expected '${response.brandName}', received '${this.userDetails.brandName}'`);
          return;
        }
        if (!response.topicsubtopic) {
          console.error("No topics found for app:", this.userDetails.brandName);
          return;
        }
        this.topicsubtopics = Object.entries(response.topicsubtopic).map(([key, value]) => ({
          title: key,
          value: value as TopicOption[],
        }));
        this.openDialog();
      });
    });
  }

  openDialog() {
    this.dialog.open(CalendlyTopicDialogComponent, {
      data: {
        userDetails: this.userDetails,
        topicSubtopics:this.topicsubtopics
      },
      disableClose: true,
    });
  }
  
}
